import {
    AccidentalDamage,
    ElectronicsFailure,
    LiquidDamage,
    ScreenDamage,
} from '@components/mpos/partner/constants';
import { AMAZON_REDIRECTION, PROJECT_ALL_IN } from '@utils/constants';

export const getImageBasePath = (imagePath: string) => {
    const imageStaticPath = process.env.NEXT_ASSET_PREFIX
        ? process.env.NEXT_ASSET_PREFIX.split('/next_assets')[0]
        : '';

    const basePath = imageStaticPath
        ? `${imageStaticPath}/_next_static`
        : '/_next_static';
    if (basePath === '/_next_static') {
        return imagePath;
    }
    return `${basePath}${imagePath}`;
};

export const getTncLink = () => {
    try {
        const staticPath = process.env.NEXT_ASSET_PREFIX
            ? process.env.NEXT_ASSET_PREFIX.split('/next_assets')[0]
            : '';
        return `${staticPath}/_next_static/static/mpos_customer_tnc.html`;
    } catch {
        return `/_next_static/static/mpos_customer_tnc.html`;
    }
};

export const getCoverage = (plan: string) => {
    try {
        if (plan.includes('Screen Damage')) {
            return [ScreenDamage];
        }
        if (plan.includes('Comprehensive')) {
            return [LiquidDamage, AccidentalDamage];
        }
        if (plan.includes('Extended Warranty')) {
            return [ElectronicsFailure];
        }
        return [];
    } catch {
        return [];
    }
};

export const whatsCoverText = (plan: string) => {
    try {
        if (plan?.includes('screen damage')) {
            return 'Screen damage';
        }
        if (plan?.includes('comprehensive')) {
            return 'Screen damage with liquid damage';
        }
        if (plan?.includes('extended warranty') || plan?.includes('_ew')) {
            return 'Electronical & mechanical failures';
        }
        return '-';
    } catch {
        return '-';
    }
};

export const getTitleCase = (str: string) => {
    return str
        .toLowerCase()
        .split(' ')
        .map((word) => {
            return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join(' ');
};

export const useProjectAllInSource = (router: any) => {
    if (typeof window !== 'undefined') {
        const querySource =
            router?.query?.source ||
            sessionStorage?.getItem(PROJECT_ALL_IN.SESSION_KEY) ||
            '';
        return querySource;
    }
    return '';
};

export const isAmazonRedirection = (policyId: string) => {
    return (
        sessionStorage?.getItem('redirectionSource') ===
        `${AMAZON_REDIRECTION.QUERY_SOURCE}_${policyId}`
    );
};

export const deleteCachedData = (policyId: string | null = null) => {
    if (typeof window === 'undefined') return;

    const localPolicyId =
        policyId ??
        new URL(window.location.href)?.searchParams?.get('policyid');

    if (!localPolicyId) return;

    try {
        const cachedClaimNumbers = localStorage.getItem('generatedClaimNumber');
        const claimNumbers =
            cachedClaimNumbers && JSON.parse(cachedClaimNumbers);
        if (claimNumbers && typeof claimNumbers === 'object') {
            delete claimNumbers[localPolicyId];
            localStorage.setItem(
                'generatedClaimNumber',
                JSON.stringify(claimNumbers)
            );
        }

        const cachedFnolData = localStorage.getItem('fnolData');
        const fnolData = cachedFnolData && JSON.parse(cachedFnolData);
        if (fnolData && typeof fnolData === 'object') {
            delete fnolData[localPolicyId];
            localStorage.setItem('fnolData', JSON.stringify(fnolData));
        }
    } catch {}
};

export const getElectronicsPdpUrl = (policyId: string) =>
    `/electronics/coi?id=${encodeURIComponent(policyId)}`;

export const clearFnolCacheAndRedirectToElectronicsPdp = (
    policyId: string | null | undefined
) => {
    if (!policyId || typeof window === 'undefined') {
        return;
    }
    deleteCachedData(policyId);
    setTimeout(() => {
        window.location.href = getElectronicsPdpUrl(policyId);
    }, 2000);
};
